import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';

import AirPump from '@/components/UI/svg/trail-series/AirPump';
import Camera from '@/components/UI/svg/trail-series/Camera';
import Drone from '@/components/UI/svg/trail-series/Drone';
import ElectricCooler from '@/components/UI/svg/trail-series/ElectricCooler';
import FishFinder from '@/components/UI/svg/trail-series/FishFinder';
import GameConsole from '@/components/UI/svg/trail-series/GameConsole';
import LEDStrip from '@/components/UI/svg/trail-series/LEDStrip';
import PortableProjector from '@/components/UI/svg/trail-series/PortableProjector';
import Speaker from '@/components/UI/svg/trail-series/Speaker';
import Tablet from '@/components/UI/svg/trail-series/Tablet';
import Fan from '@/components/UI/svg/trail-series/Fan';

import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import EFLaptop from 'elem/ui-assets/icons/appliances/EFLaptop';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import Frame from '@/components/UI/svg/trail-series/Frame';
import FishingAeratorPump from '@/components/UI/svg/trail-series/FishingAeratorPump';
import CarWasher from '@/components/UI/svg/trail-series/CarWasher';
import Phone from '@/components/UI/svg/trail-series/Phone';
import PortableNeckFan from '@/components/UI/svg/trail-series/PortableNeckFan';

export const config = () => {
    const locale = getLocal();
    const { t } = useLang('TrailSeries.tabSwriper');

    return {
        tabs: [
            {
                title: t('tab_title1'),
                items: [
                    { name: t('tab_item1_name1'), times: t('tab_item1_time1'), icon: <EFLight /> },
                    { name: t('tab_item1_name2'), times: t('tab_item1_time2'), icon: <Fan /> },
                    { name: t('tab_item1_name3'), times: t('tab_item1_time3'), icon: <AirPump /> },
                    { name: t('tab_item1_name4'), times: t('tab_item1_time4'), icon: <Speaker /> },
                ],
                pc: 'https://websiteoss.ecoflow.com/upload/image/1753952902670/300_5%202%201.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1753952902758/300_5%202%201%20(1).jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1753952903087/300_5%202%201%20(2).jpg',
            },
            {
                title: t('tab_title2'),
                items: [
                    { name: t('tab_item2_name1'), times: t('tab_item2_time1'), icon: <EFPhone /> },
                    { name: t('tab_item2_name2'), times: t('tab_item2_time2'), icon: <Camera /> },
                    { name: t('tab_item2_name3'), times: t('tab_item2_time3'), icon: <Drone /> },
                    { name: t('tab_item2_name4'), times: t('tab_item2_time4'), icon: <EFLight /> },
                ],
                pc: 'https://websiteoss.ecoflow.com/upload/image/1753669933049/tab_pc_2.png',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1753669932070/tab_pad_2.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1753669932683/tab_h5_2.png',
            },
            {
                title: t('tab_title3'),
                items: [
                    { name: t('tab_item3_name1'), times: t('tab_item3_time1'), icon: <LEDStrip /> },
                    { name: t('tab_item3_name2'), times: t('tab_item3_time2'), icon: <Frame /> },
                    { name: t('tab_item3_name3'), times: t('tab_item3_time3'), icon: <PortableProjector /> },
                    { name: t('tab_item3_name4'), times: t('tab_item3_time4'), icon: <ElectricCooler /> },
                ],
                pc: 'https://websiteoss.ecoflow.com/upload/image/1753669929887/tab_pc_3.png',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1753669931684/tab_pad_3.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1753669929599/tab_h5_3.png',
            },
            {
                title: t('tab_title4'),
                items: [
                    { name: t('tab_item4_name1'), times: t('tab_item4_time1'), icon: <Phone /> },
                    { name: t('tab_item4_name2'), times: t('tab_item4_time2'), icon: <EFLaptop /> },
                    { name: t('tab_item4_name3'), times: t('tab_item4_time3'), icon: <EFWiFi /> },
                    { name: t('tab_item4_name4'), times: t('tab_item4_time4'), icon: <GameConsole /> },
                ],
                pc: 'https://websiteoss.ecoflow.com/upload/image/1753669930749/tab_pc_5.png',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1753669930439/tab_pad_5.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1753669931314/tab_h5_5.png',
            },
            {
                title: t('tab_title5'),
                items: [
                    { name: t('tab_item5_name1'), times: t('tab_item5_time1'), icon: <FishingAeratorPump /> },
                    { name: t('tab_item5_name2'), times: t('tab_item5_time2'), icon: <EFLight /> },
                    { name: t('tab_item5_name3'), times: t('tab_item5_time3'), icon: <FishFinder /> },
                    { name: t('tab_item5_name4'), times: t('tab_item5_time4'), icon: <PortableNeckFan /> },
                ],
                pc: 'https://websiteoss.ecoflow.com/upload/image/1753669931075/tab_pc_4.png',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1753669933668/tab_pad_4.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1753669930174/tab_h5_4.png',
            },
        ],
    };
};
